// extracted by mini-css-extract-plugin
export default {"textlink":"TextLink_textlink__OsY3G"};